<template>
  <div class='coursework-viewer__users-panel'>
    <div class='coursework-viewer__users-panel_header'>
      <div class='coursework-viewer__users-panel_student-count'>
        {{ items.length > 0 ? totalItems : 'Loading...' }}
      </div>

      <div class='coursework-viewer__users-panel_close'>
        <a
          href="javascript:;"
          class='kd-ibtn kd-ibtn--light'
          @click="toggleCarousel"
          :tabindex="is_open ? '' : '-1'"
          v-focus="is_open"
        >
          <i class='kf kf-x'></i>
        </a>
      </div>
    </div>

    <div
      class='js-loader'
      id='js-coursework-entries-loader'
      style='height: 5px'></div>

    <div
      class='coursework-viewer__users-panel_main'
      id='js-courseworkEntriesHolder'
    >
      <a
        class='coursework-viewer__user-project'
        v-for="item in items"
        :key="item.id"
        @click="viewItem(item)"
        :class="{'is-selected': selectedWorkId === item.id}"
      >
        <div class='coursework-viewer__user-project_name'>{{item.title}}</div>

        <div
          class='coursework-viewer__user-project_thumb'
          :class="gradientClass(item)"
        >
          <img :src="item.thumbnail_image">
        </div>

        <div v-if="item.avatar" class='coursework-viewer__user-project_avatar'>
          <img :src="item.avatar">
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      navigation: Object,
      is_open: Boolean,
      jsonSource: [],
    },

    data() {
      return {
        meta: {},
        items: []
      }
    },

    computed: {
      totalItems() {
        return `${this.items.length} ` +
               `${this.meta.item_type.pluralize(this.items.length)}`;
      },

      selectedWorkId() {
        return this.$parent.work.id
      }
    },

    watch: {
      is_open() {
        if (this.is_open) {
          this.init();
        }
      }
    },

    methods: {
      makeRequest: _.memoize((url, loadingIndicator) => {
        return new Kadenze.AjaxRequest({
          type: 'GET',
          url: url,
          loadingIndicator: loadingIndicator
        });
      }),
      init() {
        const response = this.makeRequest(this.navigation.browse_url, {container: this.$el, positionTop: 'absolute'});
        response.done((response) => {
          this.meta = response.meta;
          this.items = response.items;
        });
      },
      toggleCarousel() {
        this.$emit('toggleCarousel')
      },
      gradientClass(item) {
        let className = null;
        if (_.isEmpty(item.thumbnail_image)) {
          let gradient_index = item.id % Kadenze.GRADIENTS.length;
          className = Kadenze.GRADIENTS[gradient_index];
        }
        return className;
      },
      viewItem(item) {
        const response = this.makeRequest(item.detail_url, {container: this.$el, positionTop: 'absolute'});
        response.done((response) => {
          this.$emit('navChanged', response);
        });
      }
    },
    mounted() {

    }
  }
</script>